/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

import * as t from "./types";
import { fetch, apiBaseUrl } from "../../util";

// the actual redux action to initiate the load of users via a remote api. Note
// the special fields "meta" and "async" in the action -- these are required in
// order for the api middleware to recognize thsi action as a remote request
// and process it accordingly

const loadLocationByLatLon = (lat, lon) => ({
    type: t.LOAD_LOCATION,
    meta: {
        path: `/location/branchbylatlon/${encodeURIComponent(
            lat
        )}/${encodeURIComponent(lon)}`,
        async: true
    }
});

const loadLocationByZip = zip => ({
    type: t.LOAD_LOCATION,
    meta: { path: `/location/branchbyzip/${zip}`, async: true }
});

const loadLocation = (locationPath = "") => ({
    type: `${t.LOAD_LOCATION}`,
    meta: {
        path: `/location/${locationPath}`,
        async: true
    }
});

const loadLocationFailed = error => ({
    type: `${t.LOAD_LOCATION}_FAILED`,
    payload: error
});

const jumpToCurrentLocationFailed = error => ({
    type: `${t.JUMP_TO_CURRENT_LOCATION}_FAILED`,
    payload: error
});

const getCurrentPositionSuccess = (coords, goFunc, resolve, dispatch) =>
    fetch(
        `${apiBaseUrl}/location/branchbylatlon/${encodeURIComponent(
            coords.latitude
        )}/${encodeURIComponent(coords.longitude)}`
    )
        .then(response => {
            if (!response) {
                return resolve(
                    dispatch(
                        jumpToCurrentLocationFailed(
                            "Unable to access your location."
                        )
                    )
                );
            }
            return resolve(
                goFunc("doublePath", {
                    firstPath: response.statecode,
                    secondPath: response.urlKey
                })
            );
        })
        .catch(error => resolve(dispatch(jumpToCurrentLocationFailed(error))));

const getCurrentPositionFailed = (err, resolve, dispatch) =>
    resolve(
        dispatch(
            jumpToCurrentLocationFailed(
                "Unable to access your location. Check browser settings."
            )
        )
    );

const jumpToCurrentLocation = goFunc => dispatch =>
    new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
            position =>
                getCurrentPositionSuccess(
                    position.coords,
                    goFunc,
                    resolve,
                    dispatch
                ),
            err => getCurrentPositionFailed(err, resolve, dispatch),
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        )
    );

export {
    loadLocation,
    loadLocationByZip,
    loadLocationByLatLon,
    loadLocationFailed,
    jumpToCurrentLocation
};



// WEBPACK FOOTER //
// ./ducks/location-details/actions.js